<template>
    <div>
        <breadcrumbs>
            Bedrijven
        </breadcrumbs>

        <div class="flex justify-between items-center">
            <h1 class="text-5xl text-teal-800">Bedrijven</h1>
        </div>

        <div class="flex justify-between items-center mb-5">
            <div class="flex flex-col">
                <search-filter v-model="form.search" class="w-full max-w-sm mr-4" @reset="reset" @input="submitSearch">
                    <label class="block text-grey-darkest">Trashed:</label>
                    <select v-model="form.trashed" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option value="with">With Trashed</option>
                        <option value="only">Only Trashed</option>
                    </select>
                    <label class="block text-grey-darkest">Logo:</label>
                    <select v-model="form.haslogo" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option value="yes">Has logo</option>
                        <option value="no">Doesnt have logo</option>
                    </select>

                    <!-- <label class="block text-grey-darkest mt-3">Active:</label>
                    <select v-model="form.active" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option value="true">Only Active</option>
                        <option value="false">Only Inactive</option>
                    </select> -->
                </search-filter>

                <active-filters :filters="filters" @remove-filter="removeFilter" />
            </div>

            <num-results name="companies"
                         :from="companies.from"
                         :to="companies.to"
                         :total="companies.total"
            />

            <input type="hidden" v-model="form.orderBy" />
            <input type="hidden" v-model="form.sortOrder" />
        </div>

        <p v-if="!companies.data.length">Er zijn geen bedrijven gevonden.</p>

        <table v-else class="w-full whitespace-no-wrap bg-white rounded">
            <thead>
                <tr class="text-teal-800 font-bold">
                    <td class="text-center" width="10">
                        <a v-if="filters.trashed" href @click.prevent="sort('deleted_at')">
                            <i class="fad fa-trash mr-1"></i><sort-icon col="deleted_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>
                    <th class="px-3 py-3">
                        <a href @click.prevent="sort('id')" class="hover:underline"> ID<sort-icon col="id" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                    </th>
                    <td class="px-3 py-3">
                        <a href @click.prevent="sort('created_at')" class="hover:underline">
                            <i class="fal fa-calendar-plus mr-1"></i>Created<sort-icon col="created_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>
                    <td class="px-3 py-3">
                        <a href @click.prevent="sort('media_count')" class="hover:underline">
                            Logo<sort-icon col="media_count" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>
                    <td class="px-3 py-3">
                        <a href @click.prevent="sort('name')" class="hover:underline"> Name<sort-icon col="name" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                    </td>
                    <td class="px-3 py-3">
                        <a href @click.prevent="sort('job_offers_count')" class="hover:underline">
                            Vacatures<sort-icon col="job_offers_count" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>
                    <td width="200"></td>
                </tr>
            </thead>

            <tr
                v-for="(company, index) in companies.data"
                :key="companies.id"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="{ 'bg-teal-100': !(index % 2), 'text-gray-500': company.deleted_at }"
            >
                <td class="border-t" width="10">
                    <span v-if="company.deleted_at" class="text-gray-500 mx-5"><i class="fad fa-trash mr-1"></i></span>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.companies.show', company.id)" tabindex="-1">
                        {{ company.id }}
                    </inertia-link>
                </td>

                <td class="border-t">
                    <inertia-link class="py-4 flex items-center" :href="route('admin.companies.show', company.id)" tabindex="-1">
                        <div v-if="company.created_at">
                            {{ moment(company.created_at).format("DD-MM-YYYY") }}
                        </div>
                    </inertia-link>
                </td>

                <td class="border-t">
                    <inertia-link class="flex items-center focus:text-teal-800 truncate" :href="route('admin.companies.show', company.id)">
                        <img v-if="company.logo" :src="company.logo" alt="" width="40" />
                    </inertia-link>
                </td>

                <td class="border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.companies.show', company.id)">
                        {{ company.name | truncate(50) }}
                    </inertia-link>
                </td>

                <td class="border-t text-left">
                    <inertia-link class="py-4 pl-8 focus:text-teal-800 truncate" :href="route('admin.companies.show', company.id)">
                        {{ company.job_offers_count }}
                    </inertia-link>
                </td>

                <!-- <td class="text-right pr-5 border-t">
                    <active-toggle :active="company.active" :url="route('admin.companies.activate', company.id)" />
                </td> -->

                <td class="text-right pr-5 border-t">
                    <div v-if="!company.deleted_at">
                        <link-button :href="route('admin.companies.edit', company.id)" icon="pencil" class="hover:bg-white"></link-button>
                        <!-- <simple-button icon="trash" class="hover:bg-red-600 hover:text-white" @click="deleteBlog(company)"></simple-button> -->
                    </div>
                </td>
            </tr>
        </table>

        <pagination :links="companies.links" />
    </div>
</template>

<script>
import _ from "lodash";
import Layout from "@/admin/Shared/Layout";
import SortIcon from "@/admin/Shared/SortIcon";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Pagination from "@/admin/Shared/Pagination";
import { Inertia } from "@inertiajs/inertia";
import SearchFilter from "@/admin/Shared/SearchFilter";
import ToggleActiveIcon from "@/admin/Shared/ToggleActiveIcon";
import ActiveFilters from "@/admin/Shared/ActiveFilters";
import NumResults from "@/admin/Shared/NumResults";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";

export default {
    metaInfo: { title: "Companies" },

    layout: Layout,

    mixins: [Helpers],

    components: {
        Pagination,
        SearchFilter,
        ActiveFilters,
        SortIcon,
        ActiveToggle: ToggleActiveIcon,
        NumResults,
        Breadcrumbs,
        LinkButton
    },

    props: {
        companies: Object,
        filters: Object
    },
    data() {
        return {
            form: {
                trashed: this.filters.trashed,
                active: this.filters.active,
                haslogo: this.filters.haslogo,
                search: this.filters.search,
                orderBy: this.filters.orderBy,
                sortOrder: this.filters.sortOrder
            }
        };
    },
    methods: {
        reloadData() {
            let queryParams = _.pickBy(this.form);
            this.$inertia.replace(this.route("admin.companies.index", Object.keys(queryParams).length ? queryParams : { remember: "forget" }));
        },

        sort(col) {
            this.form.sortOrder = this.getNewSortOrder(col, this.form.orderBy, this.form.sortOrder);
            this.form.orderBy = col;
            this.reloadData();
        },

        submitSearch: _.debounce(function() {
            this.reloadData();
        }, 250),

        reset() {
            this.form = _.mapValues(this.form, () => null);
            this.reloadData();
        },

        removeFilter(filterName) {
            this.form[filterName] = null;
            this.reloadData();
        }
    }
};
</script>
